import $common from '../common'

export default {
	namespaced: true,
	state: {
		redirect: '' // 重新登录后的重定向地址
	},
	getters: {
		getRedirect: state => $common.storeGetterSessionCommon(state, 'redirect')
	},
	mutations: {
		['SET_REDIRECT'](state, val) {
			state.redirect = val
			window.sessionStorage.setItem('redirect', val)
		}
	},
	actions: {}
}
